import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { musicVideoEditorPath } from '../../../musicVideoEditor/musicVideoEditorPath';

/**
 * Opens the music video editor of a song (spec 2026-10-09 §4.6, D11), with a cut when one is given
 * ("Edit the video"). "Back" of the editor comes to this page (`from`), as the cover editor does.
 */
export function useOpenMusicVideoEditor(accountId: number | null | undefined) {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  return useCallback(
    (catalogItemUuid: string, cut?: string | null) => {
      // The router paths have no `/app`: the editor gets the path of this page as react-router has it.
      // eslint-disable-next-line no-void -- a router navigation: nothing to wait for
      void navigate(musicVideoEditorPath(catalogItemUuid, { accountId, cut, from: `${pathname}${search}` }));
    },
    [accountId, navigate, pathname, search]
  );
}
